import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import NotFound from 'components/PageComponents/NotFound'

const NotFoundPage = () => (
  <>
    <Helmet>
      <title>Skefto: Page not found</title>
    </Helmet>
    <NotFound />
  </>
)

export default NotFoundPage
